module.exports = __webpack_public_path__ + "static/media/edit.bf93e449.svg";